import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AddIcon from '@mui/icons-material/Add';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Avatar, Button, Card, CardContent, CircularProgress, Container, CssBaseline, Grid, Pagination, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import FirstElement from '../../components/first-element';
import Footer from '../../components/footer';
import HeaderMenu from '../../components/header-menu';
import CustomizedSnackbars from '../../components/material-snackbars';
import MyMaterialTable from '../../components/table';
import { AbilityContext } from '../../config/ability-context';
import * as componentActions from '../../redux/actions/channels';
import Api from '../../services/api';
import Api2Talk from "../../services/api2talk";
import { Overlay } from '../../styles/global';
import { Styles } from '../../styles/material-styles';
import { PapiroConsole } from '../../utils/papiroConsole';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleAutoCompleteMultiple from "src/components/auto-complete/autocomplete-multiple";
import ClearIcon from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';

class Channel extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;

        const { userSession } = this.props;

        const intl = this.props.intl;

        const activeMessageOptionsList = [
            { name: intl.formatMessage({ id: "active.2" }), id: 1 },
            { name: intl.formatMessage({ id: "inactive" }), id: 0 },
        ];

        this.state = {
            hasRegisteredChannels: null,
            hasFiltersApplied: false,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
            totalPages:0,
            page:1,
            pageStart:0,
            pageEnd:0,
            count:0,
            searchValue: '',

            optionsMessageProviders: [],
            messageProviders: [],

            activeMessageOptions: activeMessageOptionsList,
            activeSelect: null
        };

        this.getItens = this.getItens.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.changeValues = this.changeValues.bind(this);
        this.fetchOptionsMessageProvider = this.fetchOptionsMessageProvider.bind(this);
    }

    fetchOptionsMessageProvider = async () => {
        if (!this.state.loading)
            this.setState({ loading: true });

        Api2Talk.get(`/messageprovider`)
            .then(result => {
                if (result.data.success) {
                    const messageProviderOptions = result.data.data;
                    this.setState(prevState => ({
                        optionsMessageProviders: messageProviderOptions,
                        loading: false
                    }))
                } else {
                    this.fetchDataNotSuccess(result);
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                this.fetchDataThrowError(err);
                Api.kickoff(err);
            });
    }

    onChangePaginate = (e,page) =>{
        this.setState({ page:page });
        this.getItens(page);
    }

    setPagination(count,page){              
        let totalPage = Math.ceil (count/10);
        this.setState({ totalPages:totalPage })
        if(count > 0){
            if(page == 1){
                this.setState({pageStart:1,pageEnd:10});
            } else{
                let pageStart = ((page - 1) * 10) + 1;
                if(count >= page * 10){
                    this.setState({pageStart:pageStart,pageEnd:page * 10});
                } else{
                    this.setState({pageStart:pageStart,pageEnd:count});
                }
            }
        } else {
            this.setState({totalPages:0,page:1,count:0});
        }                   
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.location.state === "reload"){
            this.componentDidMount();
        }
    }    

    async componentDidMount() {
        await this.getItens();
        await this.fetchOptionsMessageProvider();
    }

    fetchDataNotSuccess(result) {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
    }

    fetchDataThrowError(err) {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
    }

    getItens(page = 1) {
        const parsedPage = Number(page);
        const normalizedPage = Number.isInteger(parsedPage) && parsedPage > 0
            ? parsedPage
            : 1;

        this.setState({ loading: true, page: normalizedPage });

        const queryParams = new URLSearchParams();
        queryParams.set('page', String(normalizedPage));

        const activeSelect = this.state.activeSelect;
        const hasActiveFilter = activeSelect != null && (
            typeof activeSelect !== 'object' || activeSelect.name !== ''
        );

        if (hasActiveFilter) {
            const activeValue = typeof activeSelect === 'object'
                ? activeSelect.id
                : activeSelect;

            queryParams.set(
                'Active',
                String(activeValue === true || Number(activeValue) === 1)
            );
        }

        const selectedMessageProviderIds = (this.state.messageProviders || [])
            .map(messageProvider => Number(messageProvider?.id ?? messageProvider))
            .filter(messageProviderId => Number.isInteger(messageProviderId) && messageProviderId > 0);

        selectedMessageProviderIds.forEach(messageProviderId => {
            queryParams.append('MessageProviders', String(messageProviderId));
        });

        const hasFiltersApplied = hasActiveFilter || selectedMessageProviderIds.length > 0;

        const url = `/channel/paginate?${queryParams.toString()}`;
        
        Api2Talk.get(url)
            .then(result => {
                this.setState({ loading: false });
                if (result.data.success) {
                    PapiroConsole.log(result)
                    PapiroConsole.log("result")
                    const count = result.data.count;
                    this.setPagination(count, normalizedPage);
                    const formattedList = result.data.data.map(item => {
                        return {...item}
                    });
                    this.setState(prevState => {
                        const hasRegisteredChannels = hasFiltersApplied && count === 0
                            ? prevState.hasRegisteredChannels
                            : count > 0;

                        return {
                            loading: false,
                            resultList: formattedList,
                            count,
                            hasFiltersApplied,
                            hasRegisteredChannels
                        };
                    });
                } else {
                    this.fetchDataNotSuccess(result);
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                this.fetchDataThrowError(err)
                Api.kickoff(err);
            });
    };

    async changeValues(stateName, value, text = '') {
        this.setState({ [stateName]: value })
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page:1 });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    deleteItem(data, resolve) {
        const intl = this.props.intl;

        Api2Talk.delete(`/channel/${data.id}`)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({id:"delete.sucess"}),
                        resultList: []
                    });
                    this.getItens();
                } else {
                    this.fetchDataNotSuccess(result);
                    Api.kickoff(result);
                }
                resolve();
            })
            .catch(err => {
                resolve();
                this.fetchDataThrowError(err);
                Api.kickoff(err);
            });
    };

    clearFields(){
        this.setState({
            searchValue: '',
            messageProviders: [],
            activeSelect: null,
            page: 1,
            loading: true
        }, () => this.getItens(1));
    }

    render() {

        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;
        const showFirstChannel = this.state.hasRegisteredChannels === false
            && !this.state.hasFiltersApplied;

        if (Api == null) {
            var lang = this.props.match.params.lang;
            document.location.href = `/${lang}/unavailable`
        }

        return (
          <div className={classes.root} style={{paddingLeft:0, marginLeft:0}}>
            <HeaderMenu />
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: headerMenu.open,
                }, classes.actionsContent, {
                    [classes.actionscontentShift]: actionsHeaderMenu.open,
                })}
            >
                <div className={classes.drawerHeader} />
                <Container component='main' maxWidth='xl' style={{paddingLeft:0, marginLeft:0}}>
                    
                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}
                    
                    {!showFirstChannel ? (
                        <div>
                            <CssBaseline />
                            <Grid container className={classes.mb20}  spacing={0}>             
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    size='large'
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    disabled={!this.context.can('Add', 'Group')}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/channel-registration` }}
                                >
                                    {<FormattedMessage id="add" />}
                                </Button>
                            </Grid>

                            <Grid container spacing={6} alignItems="center"> 
                                <Grid item xs={12} sm={12}>
                                    <Card className="background-title-search">
                                        <CardContent> 
                                            <Grid container xs={12} spacing={2} alignItems="center">
                                                
                                                <Grid item xs={12}>
                                                    <Typography variant="h5">
                                                        {<FormattedMessage id="channel.header" />}
                                                    </Typography>
                                                </Grid>

                                                <Grid container item xs={9} spacing={3} alignItems="center">
                                                    <Grid item sm={5}>
                                                        <SimpleAutoCompleteMultiple
                                                            name="messageProviders"
                                                            label={intl.formatMessage({ id: "select.message_provider" })}
                                                            options={this.state.optionsMessageProviders}
                                                            stateName='messageProviders'
                                                            changeSelect={this.changeValues}
                                                            selected={this.state.messageProviders}
                                                            htmlOptions={true}
                                                        />
                                                    </Grid>

                                                    <Grid item sm={5}>
                                                        <SimpleAutoComplete
                                                            name='activeSelect'
                                                            label={intl.formatMessage({ id: "active" })}
                                                            options={this.state.activeMessageOptions}
                                                            stateName='activeSelect'
                                                            selected={this.state.activeSelect}
                                                            changeSelect={this.changeValues}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container item xs={3} spacing={1} alignItems="center" justifyContent="center">
                                                    <Grid container item xs={6} sm={6} md={3}>
                                                        <Button
                                                            variant='contained'
                                                            color='secondary'
                                                            size='large'
                                                            className={classes.button}
                                                            onClick={() => this.getItens(1)}
                                                        >
                                                            <Search />
                                                        </Button>

                                                    </Grid>

                                                    <Grid container item xs={6} sm={6} md={3}>
                                                        <Button
                                                            variant='outlined'
                                                            color='primary'
                                                            size='large'
                                                            className={classes.button}
                                                            onClick={() => this.clearFields()}
                                                        >
                                                            <ClearIcon />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>                                
                            </Grid>  

                            <MyMaterialTable
                                title=""
                                rowClick={(event, rowData) => {     
                                    this.props.addCurrent(rowData);
                                    this.props.history.push(`/${this.props.match.params.lang}/channel-edit`);
                                }}
                                columns={[
                                    { 
                                        title: "", 
                                        render: (row) => {
                                            return row?.chatbotid ? (
                                                <Avatar style={{ backgroundColor: '#303f9f', color: 'white', width: '28px', height: '28px' }}>
                                                    <SmartToyIcon style={{ width: '20px', height: '20px' }}/>
                                                </Avatar>
                                            ) : ""
                                        },
                                    },
                                    { 
                                        title: "Chatbot", 
                                        field: 'chatbotname' 
                                    },
                                    { 
                                        title: intl.formatMessage({id:"id"}), 
                                        field: 'id',

                                    },
                                    { 
                                        title: intl.formatMessage({id:"name"}), 
                                        field: 'name' 
                                    },
                                    { 
                                        title: intl.formatMessage({id:"label.message_provider"}), 
                                        render: (row) => {
                                            return row?.messageprovider?.name ?? "N/A"
                                        }
                                    },
                                    { 
                                        title: intl.formatMessage({id:"team"}), 
                                        render: (row) => {
                                            return row?.channeltechinicalteams[0]?.techinicalteam?.name ?? "N/A"
                                        }
                                    },
                                    { 
                                        title: intl.formatMessage({id:"label.time_warning_inactivity"}), 
                                        render: (row) => {
                                            return row?.channelsettings?.notificationleadtime ? `${row?.channelsettings?.notificationleadtime?.toString()} ${intl.formatMessage({id:"label.minutes"})}` :  "N/A"
                                        }
                                    },
                                    { 
                                        title: intl.formatMessage({id:"label.time_inactivity"}), 
                                        render: (row) => {
                                            return row?.channelsettings?.inactivitytimevalue ? `${row?.channelsettings?.inactivitytimevalue?.toString()} ${intl.formatMessage({id:"label.minutes"})}` : "N/A"
                                        }
                                    },
                                    { 
                                        title: intl.formatMessage({id:"published"}), 
                                        render: (row) => {
                                            return row?.published ? intl.formatMessage({id:"yes"}) : intl.formatMessage({id:"no"})
                                        }
                                    },
                                    { 
                                        title: intl.formatMessage({id:"active"}), 
                                        render: (row) => {
                                            return row?.active ? intl.formatMessage({id:"yes"}) : intl.formatMessage({id:"no"})
                                        }
                                    },
                                ]}
                                data={this.state.resultList}
                                deleteItem={this.deleteItem}                 
                            />

                            <Grid container style={{marginBottom:12,marginTop:8}}>
                                <Grid item xs={12} md={3}>
                                    <Pagination  count={this.state.totalPages} page={this.state.page}  onChange={this.onChangePaginate} />
                                </Grid>
                                <Grid item xs={12} sm={3} style={{marginTop:6}}>
                                    {this.state.pageStart} &nbsp;
                                    {<FormattedMessage id="to" />} &nbsp; 
                                    {this.state.pageEnd} &nbsp;
                                    {<FormattedMessage id="of" />} &nbsp; 
                                    {this.state.count} &nbsp;
                                    {<FormattedMessage id="register" />}
                                </Grid>
                            </Grid>
        
                        </div>)
                    :(
                        <div>
                            <FirstElement
                                title = {intl.formatMessage({id:"group.list.create.first.channel"})}
                                subtitle = {intl.formatMessage({id:"group.list.create.channels"})}
                                buttonText = {
                                    <Button
                                    variant='contained'
                                    color='secondary'
                                    size='large'
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/channel-registration` 
                                }}>
                                {<FormattedMessage id="add" />}
                                </Button>
                                }
                                icon = {<AccountBalanceWalletIcon style={{fontSize: "45px"}} />}
                            />
                        </div>
                    )}

                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}

                    <CustomizedSnackbars
                        variant={this.state.notificationVariant}
                        message={this.state.notificationMessage}
                        isOpen={this.state.openNotification}
                        toClose={this.closeNotification}
                    />
                </Container>
            </main>
            <Footer />   
        </div>
        );
    }
}

Channel.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(Channel)));

Channel.contextType = AbilityContext;